@if( hasSearch() ){

  @if(inline) {

  <!-- INLINE VERSION: fills available space in the topbar right section -->
  <div #searchWrapper
      class="flex items-center justify-end gap-x-2"
      [class.flex-1]="showSearch"
      [class.hidden]="hideSearchByView"
  >

    <!-- SEARCHER -->
    <div #searchContainer class="flex items-center gap-x-2 flex-1 transition opacity-0" [class]="{'hidden': !showSearch}">

      <!-- CLOSE BUTTON — rests on the brand color when there is no gradient topbar behind it -->
      <app-button
        [type]="buttonType"
        [disabled]="isAnimating()"
        [color]="iframeMode || isMobile() ? ButtonColors.Brand : ButtonColors.Default"
        (click)="toggleSearchButton()"
        >

        <svg ngProjectAs="icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-3.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>

      </app-button>

      <!-- SEARCH INPUTS -->
      <div class="flex-1 min-w-0">
        @switch (type()) {
          @case (searchTypes.Simple) {
            <app-search-simple/>
          }
          @case (searchTypes.Advanced) {
            <app-search-advanced [data]="fileData()"/>
          }
        }
      </div>

    </div>

    <!-- MAIN SEARCH BUTTON -->
    <app-button
      #searchBtn
      [custom]="searchActive() ? ['cursor-default'] : []"
      [type]="buttonType"
      [active]="searchActive()!"
      (click)="navigateTo()"
      >

      <svg ngProjectAs="icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="size-3.5 rotate-90">
        <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>

    </app-button>

  </div>

  } @else {

  <!-- ORIGINAL VERSION: absolute overlay (used in footer/mobile) -->
  <div #searchWrapper class="relative" [class]="{'hidden': hideSearchByView}">

    <!-- SEARCHER -->
    <div #searchContainer class="absolute top-0 z-[1] flex items-center gap-x-2 transition opacity-0 w-[calc((100vw-64px)-var(--spacing)*2)] lg:w-[300px]" [class]="{'hidden': !showSearch}">

      <!-- CLOSE BUTTON — rests on the brand color when there is no gradient topbar behind it -->
      <app-button
        [type]="buttonType"
        [disabled]="isAnimating()"
        [color]="iframeMode || isMobile() ? ButtonColors.Brand : ButtonColors.Default"
        (click)="toggleSearchButton()"
        >

        <svg ngProjectAs="icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-3.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>

      </app-button>


      <!-- SEARCH INPUTS -->
      @switch (type()) {
        <!-- SIMPLE SEARCH -->
        @case (searchTypes.Simple) {
          <app-search-simple
            />
        }
        <!-- ADVANCED SEARCH -->
        @case (searchTypes.Advanced) {
          <app-search-advanced
            [data]="fileData()"
            />
        }
      }

    </div>

    <!-- MAIN SEARCH BUTTON -->
    <app-button
      #searchBtn
      [custom]="searchActive() ? ['cursor-default'] : []"
      [type]="buttonType"
      [active]="searchActive()!"
      (click)="navigateTo()"
      >

      <svg ngProjectAs="icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="size-3.5 rotate-90">
        <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>

    </app-button>

  </div>

  }

}
